export const newsEventSubscriptionDefault = {
  id: null,
  email: null,
  listingId: null,
  companyName: null,
  active: false,
  language: "ENGLISH",
  themes: [],
  triggers: [],
};
